import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserApiCall } from "../../store/actions/projectAction";

function PrivateRoute({ children, role = ["user"] }) {
  const user = useSelector((state) => state.project?.user);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initPage = async () => {
    try {
      // Try to get user info using session cookie (no need to check localStorage)
      const user = await dispatch(getUserApiCall()).unwrap();

      if (window?.location?.pathname == "/" && user?.role == "admin") {
        navigate("/admin/projects");
      }
    } catch (error) {
      // If getUserApiCall fails, it means no valid session cookie or user not found
      localStorage.removeItem("token"); // Clean up any old tokens
      navigate("/auth/login");
    }
  };

  useEffect(() => {
    initPage();
  }, []);

  if (!user) {
    return null;
  }

  if (
    (window.location.pathname == "/admin" || window.location.pathname == "/") &&
    user?.role == "admin"
  ) {
    navigate("/admin/projects");
  }

  if (role.includes("admin") && role.includes("user") && user?.role) {
    return children;
  }

  if (role.includes("admin") && user?.role != "admin") {
    return (
      <div>
        <h1>You don't have access to this page</h1>
      </div>
    );
  }

  if (role.includes("user") && user?.role != "user") {
    return (
      <div>
        <h1>You don't have access to this page</h1>
      </div>
    );
  }

  return children;
}

export default PrivateRoute;
